import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';

import { S3UploadComponent } from './s3-upload.component';
import { AwsS3UploadComponent } from './aws-s3-upload/aws-s3-upload.component';
import { AwsS3UploadComponentDrive } from './aws-s3-upload-drive/aws-s3-upload.component';
import { ListViewComponent } from './aws-s3-upload/list-view/list-view.component';
import { S3UploadImageComponent } from './s3-upload-image/s3-upload-image.component';
import { S3UploadDocumentComponent } from './s3-upload-document/s3-upload-document.component';
import { ItemUploadComponent } from './item-upload/item-upload.component';
import { AwsItemUploadComponent } from './aws-s3-upload/aws-item-upload/aws-item-upload.component';
import { ModalComponent } from './modal/modal.component';
import { DndDirective } from './dnd.directive';
import { BytesPipe } from './bytes.pipe';
import { FolderUploadComponent } from './aws-s3-upload/folder-upload/folder-upload.component';

@NgModule({
  declarations: [
    S3UploadComponent,
    AwsS3UploadComponent,
    AwsS3UploadComponentDrive,
    ListViewComponent,

    S3UploadImageComponent,
    S3UploadDocumentComponent,
    ItemUploadComponent,
    AwsItemUploadComponent,
    DndDirective,
    BytesPipe,
    ModalComponent,
    FolderUploadComponent,
  ],
  imports: [
    CommonModule,
    ProgressbarModule.forRoot(),
    PopoverModule.forRoot(),
    NgxFileDropModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
    }),
    ModalModule.forRoot(),
  ],
  exports: [
    S3UploadComponent,
    AwsS3UploadComponent,
    AwsS3UploadComponentDrive,

    S3UploadImageComponent,
    S3UploadDocumentComponent,
    ItemUploadComponent,
    AwsItemUploadComponent,
    ModalComponent,
  ],
  providers: [BsModalService],
})
export class S3UploadModule {}
